<div class="bg-light-grey">
    <div *ngIf="order.suborders.length > 1" class="tabs pt-16">
        <ul class="list-equal">
            <li
                *ngFor="let suborder of order.suborders; let index = index"
                class="cursor-pointer"
                [ngClass]="{ 'is-active': (subOrderSelected$ | async) === suborder.id }"
                (click)="handleChangeOrderSelected(suborder.id)"
            >
                <span>{{
                    'dev.orders.delivery'
                        | translate
                            : {
                                  $0: index + 1,
                                  $1: order.suborders.length
                              }
                }}</span>
            </li>
        </ul>
    </div>

    <div class="p-16">
        <ng-container *ngIf="fromOnline$ | async">
            <div class="row mb-16">
                <div class="col-xs-12 col-sm-6 smmax:mb-16">
                    <div class="is-flex flex-column p-16 h-100 border-1 bg-white">
                        <span class="text-l mb-8 border-b2">{{ 'dev.delivery.dataTitle' | translate }}</span>

                        <div>
                            <span class="title-s ttu mr-8">{{ 'dev.productView.shipping' | translate }}:</span>
                            <span class="c-gray">{{ order.shipping.name }}</span>
                            <div *ngIf="orderIsCanceled$ | async" class="is-flex flex-column">
                                <ng-container *ngIf="orderAddress$ | async as orderAddress">
                                    <span>{{ orderAddress.addressLines }}</span>
                                    <span *ngIf="orderAddress.address">{{ orderAddress.address.stateName + ' ' + orderAddress.city }}</span>
                                    <span *ngIf="orderAddress.address">{{ orderAddress.address.zipCode + ' ' + orderAddress.district }}</span>
                                </ng-container>
                            </div>
                        </div>

                        <div>
                            <span class="title-s ttu mr-8">{{ 'dev.myAccount.orders.detail.pago' | translate }}:</span>
                            <span class="c-gray">{{ paymentName$ | async }}</span>
                        </div>

                        <div *ngIf="!openedDetail">
                            <span class="title-s ttu mr-8">
                                {{
                                    ((haveEmail$ | async) ? 'dev.logonView.logon.input.email' : 'dev.commonErrorFields.input.mobileNumber')
                                        | translate
                                }}:
                            </span>
                            <span *ngIf="haveEmail$ | async" class="c-gray">{{ userEmail$ | async }}</span>
                            <span *ngIf="(haveEmail$ | async) === false" class="c-gray">{{ userPhone$ | async }}</span>
                        </div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6">
                    <div class="is-flex flex-column p-16 h-100 border-1 bg-white">
                        <span class="text-l mb-8 border-b2">{{ 'dev.myAccount.orders.detail.summaryTitle' | translate }}</span>
                        <dumb-order-summary [order]="mappedOrder" [isHistory]="true"></dumb-order-summary>
                    </div>
                </div>
            </div>

            <div class="row mb-16">
                <div class="col-xs-12">
                    <order-tracking
                        [order]="mappedOrder"
                        [orderAddress]="orderAddress$ | async"
                        [selectedSuborder]="subOrderSelected$ | async"
                    ></order-tracking>
                </div>
            </div>
        </ng-container>

        <div *ngIf="(showWechat$ | async) === true" class="row mb-16">
            <div class="col-xs-12">
                <payment-qr
                    [image]="image"
                    [cancelled]="cancelled"
                    [pending]="pending"
                    [qr]="qr"
                    [total]="total$ | async"
                    [mainText]="wechatKeys.mainText"
                    [pendingText]="wechatKeys.pendingText"
                    [cancelledText]="wechatKeys.cancelledText"
                ></payment-qr>
            </div>
        </div>

        <div *ngIf="(showBancontactQr$ | async) === true" class="row mb-16">
            <div class="col-xs-12">
                <payment-qr
                    [image]="image"
                    [cancelled]="cancelled"
                    [pending]="pending"
                    [qr]="qr"
                    [total]="total$ | async"
                    [mainText]="bancontactKeys.mainText"
                    [pendingText]="bancontactKeys.pendingText"
                    [cancelledText]="bancontactKeys.cancelledText"
                ></payment-qr>
            </div>
        </div>

        <div *ngIf="(showSwishQr$ | async) === true" class="row mb-16">
            <div class="col-xs-12">
                <payment-qr
                    [image]="image"
                    [cancelled]="cancelled"
                    [pending]="pending"
                    [qr]="qr"
                    [total]="total$ | async"
                    [mainText]="swishKeys.mainText"
                    [pendingText]="swishKeys.pendingText"
                    [cancelledText]="swishKeys.cancelledText"
                ></payment-qr>
            </div>
        </div>

        <div class="row mb-16">
            <div class="col-xs-12">
                <div class="is-flex flex-column border-1 bg-white">
                    <accordion-item>
                        <div accordion-item-title class="px-16">
                            <span class="text-l">
                                {{ (itemsByOrderSelected$ | async).length }}
                                {{ ((itemsByOrderSelected$ | async).length === 1 ? 'dev.general.product' : 'dev.general.products') | translate }}
                            </span>
                        </div>
                        <div accordion-item-content>
                            <div *ngFor="let item of itemsByOrderSelected$ | async" class="px-16 pt-16 border-t">
                                <item-product-cart [item]="item" [type]="itemType"></item-product-cart>
                            </div>
                        </div>
                    </accordion-item>
                </div>
            </div>
        </div>

        <div
            *ngIf="(showDownloadECOTicket$ | async) || (storeOrderTicketUrl$ | async) || (invoiceUrl$ | async) || (invoiceReturnUrl$ | async)"
            class="row mb-20"
        >
            <div *ngIf="(showDownloadECOTicket$ | async) || (storeOrderTicketUrl$ | async)" class="col-xs-12 col-md">
                <div class="is-flex flex-column align-middle content-center p-16 h-100 border-1 bg-white">
                    <span class="title-l ttu mb-16 text-center">{{ 'dev.myAccount.needECOTicket' | translate }}</span>
                    <a *ngIf="showDownloadECOTicket$ | async" class="mb-16" [href]="ecoTicketURL$ | async" target="_blank">
                        <button class="btn btn-secondary btn--large">
                            {{ 'dev.myAccount.downloadHere' | translate }}
                        </button>
                    </a>
                    <div *ngIf="storeOrderTicketUrl$ | async as storeOrderTicketUrl" class="is-flex align-center">
                        <a *ngIf="!pdfList" [href]="storeOrderTicketUrl" target="_blank">
                            <button class="link-line text-l">
                                {{ 'dev.orders.ticketDownload' | translate }}
                            </button>
                        </a>
                        <button *ngIf="pdfList" class="link-line text-l" (click)="openAllDocuments(storeOrderTicketUrl)">
                            {{ 'dev.orders.ticketDownload' | translate }}
                        </button>
                    </div>
                </div>
            </div>

            <div *ngIf="(showEgui$ | async) === false && ((invoiceUrl$ | async) || (invoiceReturnUrl$ | async))" class="col-xs-12 col-md">
                <div class="is-flex flex-column align-middle content-center p-16 h-100 border-1 bg-white">
                    <span class="title-l ttu mb-16 text-center">{{ 'dev.myAccount.invoiceRequest' | translate }}</span>

                    <ng-container *ngIf="invoiceUrl$ | async">
                        <a class="mb-16" [href]="invoiceUrl$ | async" target="_blank">
                            <button class="btn btn-secondary btn--large">
                                {{ 'dev.myAccount.downloadHere' | translate }}
                            </button>
                        </a>
                    </ng-container>

                    <div *ngIf="invoiceReturnUrl$ | async" class="is-flex align-center">
                        <a [href]="invoiceReturnUrl$ | async" target="_blank">
                            <button class="link-line text-l">
                                {{ 'dev.orders.getReturnTicket' | translate }}
                            </button>
                        </a>
                    </div>
                </div>
            </div>
            <div *ngIf="showEgui$ | async" class="col-xs-12 col-md">
                <div class="is-flex flex-column align-middle content-center p-16 h-100 border-1 bg-white">
                    <span class="title-l mb-16 text-center">{{ 'dev.checkout.EguiTW' | translate }}</span>

                    <ng-container *ngIf="invoiceUrl$ | async">
                        <button
                            class="btn btn-secondary btn--large"
                            [disabled]="(printEguiAllowed$ | async) === false"
                            (click)="requestPrintedEgui()"
                        >
                            {{ 'dev.Myaccountpedidos.printedTW' | translate }}
                        </button>
                    </ng-container>
                </div>
            </div>
        </div>

        <div *ngIf="isReturnable && (showCODReturnMessage$ | async) === true && !openedDetail && (multidevo$ | async) === false" class="row mb-20">
            <div class="col-xs-12">
                <div class="is-flex flex-column align-middle content-center p-16 h-100 border-1 bg-white">
                    <div class="text-center mb-16">
                        {{ 'dev.orders.returnOrder' | translate }}
                    </div>
                    <div>
                        <strong>{{ 'dev.myaccount.returnCod' | translate }}</strong>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="(showGiftTicketModal$ | async) && !openedDetail" class="row mb-20">
            <div class="col-xs-12">
                <div class="is-flex flex-column align-middle content-center p-16 h-100 border-1 bg-white">
                    <span class="title-l mb-8 text-center">{{ 'dev.myAccount.giftTicketDownload.order.title' | translate }}</span>
                    <div class="align-center">
                        <button class="btn btn-secondary btn--large" (click)="openGiftTicketModal()">
                            {{ 'dev.myAccount.giftTicketDownload.order.button' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="!openedDetail && order.isRefundDataNeeded" class="row mb-20">
            <div class="col-xs-12">
                <div class="is-flex flex-column align-middle content-center p-16 h-100 border-1 bg-white">
                    <span class="title-l ttu mb-8 text-center">{{ 'dev.orders.canceled' | translate }}</span>
                    <span class="text-l mb-16 text-center">{{ 'dev.orders.askRefund' | translate }}</span>
                    <button class="btn btn-secondary btn--large" type="button" (click)="orderRefundDialog(order)">
                        {{ 'dev.orders.refundForm' | translate }}
                    </button>
                </div>
            </div>
        </div>

        <div *ngIf="order.repayable && !openedDetail" class="row mb-20">
            <div class="col-xs-12">
                <div class="is-flex flex-column align-middle content-center p-16 h-100 border-1 bg-white">
                    <span class="title-l ttu mb-8 text-center">{{ 'dev.orders.pendingPayment' | translate }}</span>
                    <span class="text-l mb-16 text-center">{{ 'dev.orders.pendingPaymentLink' | translate }}</span>
                    <button class="btn btn-secondary btn--large" (click)="repay()">
                        {{ 'dev.my-account.order.repayment-link' | translate }}
                    </button>
                </div>
            </div>
        </div>

        <div *ngIf="isReturnable && (showCODReturnMessage$ | async) !== true && !openedDetail && (multidevo$ | async) === false" class="row mb-20">
            <div class="col-xs-12">
                <div class="is-flex flex-column align-middle content-center p-16 h-100 border-1 bg-white">
                    <!-- <span class="title-l ttu mb-8 text-center">{{ 'dev.orders.askReturnOrder' | translate }}</span>
                    <span class="text-l mb-16 text-center">{{ 'dev.orders.hereBtn' | translate }}</span> -->
                    <button *ngIf="(isChangeable$ | async) === false" class="btn btn-primary btn--large has-ico-pre" (click)="returnOrder(order)">
                        <svg-icon class="ico-pre ico-white" src="enter"></svg-icon>
                        {{ 'dev.orders.returnOrder' | translate }}
                    </button>
                    <button
                        *ngIf="isChangeable$ | async"
                        class="btn btn-primary btn--large has-ico-pre"
                        style="white-space: normal; height: auto"
                        (click)="changeOrder(order)"
                    >
                        <!-- <span>
                            <svg-icon class="ico-pre ico-white" src="enter"></svg-icon>
                        </span> -->
                        {{ 'dev.myAccount.returnChangeOrderRequest' | translate }}
                    </button>
                </div>
            </div>
        </div>

        <ng-container *ngIf="(fromOnline$ | async) && !openedDetail">
            <div *ngIf="isCancellableSubOrder" class="row mb-20">
                <div class="col-xs-12">
                    <div class="is-flex flex-column align-middle content-center p-16 h-100 border-1 bg-white">
                        <span class="title-l ttu mb-8 text-center">{{ 'dev.orders.askCancelSubOrder' | translate }}</span>
                        <span class="text-l mb-16 text-center">{{ 'dev.orders.hereBtn' | translate }}</span>
                        <button class="btn btn-primary btn--large has-ico-pre" (click)="cancelOrder(true)">
                            <svg-icon class="ico-pre ico-white" src="cancel-2"></svg-icon>
                            {{ 'dev.orders.suborder.cancelLowercase' | translate }}
                        </button>
                    </div>
                </div>
            </div>

            <div *ngIf="isCancellableAllOrder" class="row mb-20">
                <div class="col-xs-12 align-center" (click)="cancelOrder(false)">
                    <button class="link-line text-l">
                        {{ 'dev.orders.cancel' | translate }}
                    </button>
                </div>
            </div>
        </ng-container>
    </div>
</div>
